import { ENV } from "../Utils";

export const createThreadUseCasePublic = async (assistant_id) => {
  try {
    //console.log("assistant_id", assistant_id);
    const resp = await fetch(
      `${ENV.BASE_API}/${ENV.API_ROUTES.THREADPUBLIC}/${assistant_id}`,
      {
        method: "POST",
      },
    );
    //console.log("Final URL:", `${ENV.BASE_API}/${ENV.API_ROUTES.THREAD}/${assistant_id}`);

    if (!resp.ok) {
      throw new Error(`Error creating thread: ${resp.statusText}`);
    }

    // Captura el JSON completo
    const data = await resp.json();
    // console.log("Response data:", data);

    // Accede al threadId desde el JSON
    const threadId = data.threadId;
    //console.log("threadId", threadId);

    return threadId;
  } catch (error) {
    console.error("Error creating thread:", error);
    throw new Error("Error creating thread");
  }
};
